import { gql } from "@apollo/client";

export const GET_ALIMENTACION_ENTERAL = gql`
    query AlimentacionEnteralRIByDatosGeneralesId (
        $idDatosGenerales: Int!
    ) {
        alimentacionEnteralRIByDatosGeneralesId (
            idDatosGenerales: $idDatosGenerales
        ){
            idAlimentacionEnteralRI
            proteinasTotales
            caloriasTotales
            idComboRIValorTipoAccesoAE
            idComboRIValorTipoAccesoAENavigation{
                valor
            }
            idComboRIValorKarnofsky
            idComboRIValorKarnofskyNavigation{
                valor
            }
            cambioSNGdomicilio
            justificacionNoCambioSNG
            accesoBuenEstado
            justificarMalEstado
            idComboRIValorModoInfusionAE
            idComboRIValorModoInfusionAENavigation{
                valor
            }
            llevaBomba
        }
    }
`;